import { useEffect, useState } from "react";

import { IdentityContextProvider } from "@examspark/api";
import { AuthorizationContextInput, IdentityContext } from "@examspark/types";

import { defaultState, useAppContext } from "../providers/AppContext";

/**
 * Uses AppContext to format an `AuthorizationContextInput` for the purpose
 * of restricting queries and mutations.
 */
export const useAuthorizationContext = (): AuthorizationContextInput => {
  const [state] = useAppContext();
  const stateFromIdc = useIdentityContext();

  // fall back to IdentityContextProvider (which is set correctly in all apps theoretically)
  if (state === defaultState) {
    return {
      userId: stateFromIdc.userId,
      workspaceId: stateFromIdc.workspaceId,
      appId: stateFromIdc.appId,
    };
  }

  return {
    userId: state.user?.id,
    workspaceId: state.workspaceUser?.id,
    appId: state.app?.id,
  };
};

export const useIdentityContext = () => {
  const [context, setContext] = useState<IdentityContext>(
    IdentityContextProvider.getContext(),
  );

  useEffect(() => {
    return IdentityContextProvider.on("change", setContext);
  }, []);

  return context;
};
